import React, { forwardRef, memo } from 'react'
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Slide
} from '@mui/material'
import { faTimes } from '@fortawesome/pro-duotone-svg-icons'

import customConfig from 'customConfig'
import SubmitButton from '../button/SubmitButton'
import Button from '../button/Button'
import CustomForm from '../inputs/CustomForm'
import FaIcon from '../faIcon/FaIcon'
import CardHeading from '../text/CardHeading'

const Transition = forwardRef((props, ref) => (
  <Slide direction='up' ref={ref} {...props} />
))

const Popup = ({
  title,
  description,
  color,
  icon,
  children,
  onFormSubmit,
  submitLabel,
  cancelLabel,
  onCancel,
  status,
  submitBtnProps,
  maxWidth = 'sm',
  fullWidth = true,
  customIcon,
  scroll,
  disableClose = false,
  dividers = true,
  open = true,
  bodySx,
  banner,
  customClose = false,
  actionSx,
  alertMsg
}) => {
  const isSubmitAvailable = onFormSubmit && submitLabel
  return (
    <Dialog
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      open={open}
      onClose={!disableClose ? onCancel : () => {}}
      slots={{ transition: Transition }}
      scroll={scroll}
    >
      {customClose && (
        <IconButton
          aria-label='close'
          onClick={onCancel}
          sx={{
            position: 'absolute',
            right: 10,
            top: 10,
            width: 32,
            height: 32
          }}
        >
          <FaIcon icon={faTimes} size='sm' />
        </IconButton>
      )}
      {(icon || customIcon) && (
        <Box
          component='span'
          sx={{
            pt: 3,
            pb: 1,
            mx: 'auto',
            display: 'inline-flex',
            color: color ? `${color}.main` : 'primary.main'
          }}
        >
          {customIcon ? customIcon : <FaIcon icon={icon} size='4x' />}
        </Box>
      )}
      {banner}
      <CustomForm onSubmit={onFormSubmit}>
        {(title || description) && (
          <DialogTitle sx={{ pb: 0 }}>
            <CardHeading title={title} desc={description} noMargin />
          </DialogTitle>
        )}
        <DialogContent
          sx={{ ...(children ? { mt: 3 } : {}), ...bodySx }}
          dividers={(cancelLabel || isSubmitAvailable) && dividers}
        >
          {children}
        </DialogContent>
        {(cancelLabel || isSubmitAvailable || alertMsg) && (
          <DialogActions sx={{ py: 3, ...actionSx }}>
            {alertMsg}
            {cancelLabel && (
              <Button
                label={cancelLabel}
                onClick={onCancel}
                variant='outlined'
                color='inherit'
                size='large'
              />
            )}
            {isSubmitAvailable && (
              <SubmitButton
                label={submitLabel}
                onClick={onFormSubmit}
                {...submitBtnProps}
              />
            )}
          </DialogActions>
        )}
        {status && status}
      </CustomForm>
    </Dialog>
  )
}

const { buttonStyles } = customConfig.customCss

Popup.defaultProps = {
  submitBtnProps: { css: buttonStyles }
}

export default memo(Popup)
